'use strict';

module.exports = require('./matrix').Matrix;
module.exports.Decompositions = module.exports.DC = require('./decompositions');



//////////////////
// WEBPACK FOOTER
// ./~/ml-fnn/~/ml-matrix/src/index.js
// module id = 37
// module chunks = 0